"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconCelsius = function IconCelsius(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M15.831 5c1.918 0 3.981.75 5.169 1.834l-1.646 2.835c-.855-.834-2.127-1.439-3.44-1.439-2.042 0-3.605 1.543-3.605 3.793s1.563 3.794 3.605 3.794c1.313 0 2.585-.604 3.44-1.438L21 17.213c-1.188 1.084-3.251 1.835-5.169 1.835-3.897 0-6.94-3.023-6.94-7.025C8.89 8.022 11.934 5 15.83 5M5.21 5c1.792 0 3.23 1.417 3.23 3.168 0 1.73-1.438 3.126-3.23 3.126S2 9.898 2 8.168C2 6.418 3.418 5 5.21 5m0 1.688c-.771 0-1.418.646-1.418 1.48 0 .813.647 1.438 1.418 1.438s1.417-.625 1.417-1.438c0-.834-.646-1.48-1.417-1.48"
  })));
};

export { IconCelsius, IconCelsius as default };
